
import { CONFIG_TYPES } from '../configTypes';
import mySubscriptionsConfig from './mySubscriptions/config';

/**
 * Configuration required to render a configuration modal.
 *
 * @typedef {Object} ConfigModalConfig
 * @property {string} title Translation key used for the modal title.
 * @property {string} img Asset identifier or URL used by the modal image.
 * @property {Array<Object>|Function} buttons Buttons to render, or a function that returns them.
 */

/** @type {Object<string, ConfigModalConfig>} */
export const CONFIG_MODALS = {
    [CONFIG_TYPES.MY_SUBSCRIPTIONS]: mySubscriptionsConfig
};

/**
 * Returns the configuration for a modal and normalizes its buttons to an array.
 *
 * @param {string} configType Modal type used to find the configuration.
 * @returns {ConfigModalConfig|Object} Modal configuration, or an empty object when it is not registered.
 */
export const getConfigModal = (configType) => {
    const config = CONFIG_MODALS[configType];
    if (!config) return {};

    const buttons = typeof config.buttons === 'function'
        ? config.buttons()
        : Array.isArray(config.buttons)
            ? config.buttons
            : [];

    return {
        ...config,
        buttons
    };
};


// WEBPACK FOOTER //
// ./src/containers/config/ConfigModals/configModals.js